const state = {
	/**
	 * id
	 * thumb
	 * goodsNum
	 * name
	 * goodsId
	 * price
	 * officialPrice
	 * specs:
	 * 	  specId
	 *    itemId
	 *    itemName
	 *    upPrice
	 */
	goodsList: [],
	sortedGoodsIdList:[],
	orderId: '',
	hfOrderId:"",
	orderCode: '',
	couponObj: [],
	sortedCardIdList:[],
	wechat: false,
	actual:0, // 实际使用优惠券后的优惠价格
	uri: ''
};

// goodlist :商品价格排序数组
// pricelist ：优惠券价格
// 目的：选出最省钱的优惠券使用方法
const subduction=(goodlist,pricelist)=>{
	for (let i = 0; i < goodlist.length; i++) {
		if(pricelist[i]){
			if(pricelist[i]<goodlist[i]){
				goodlist[i]=parseFloat(goodlist[i]-pricelist[i]).toFixed(2)
			}else{
				pricelist[i] = goodlist[i]
				goodlist[i]=0
			}
		}
	}
	// console.log('选择优惠券后',goodlist,'优惠券---',pricelist);
	return {goodlist,pricelist}
}
const sordByKey=(alist,blist)=>{
	let arr=[]
	for (let i = 0; i < alist.length;) {
		const element = alist[i];
		for (let j = 0; j < blist.length; j++) {
			if((blist[j][element])){
				// console.log((blist[j][element]));
				arr.push(blist[j][element])
				// alist.splice(i,1)
				blist.splice(j,1)
				i++
				break;
			}
		}
	}
	// arr = [...new Set(arr)]
	return arr
}

const getters = {
	sOrderId: state => {
		return state.orderId;
	},
	sHfOrderId:state=>{
		return state.hfOrderId
	},
	sOrderCode: state => {
		return state.orderCode;
	},
	sCouponObj: state => {
		return state.couponObj;
	},
	sActual:state=>{
		return state.actual
	},
	sSortGood:state=>{
		return state.sortedGoodsIdList
	},
	sSortCoup:state=>{
		return state.sortedCardIdList
	},
	getGoodsList: state => {
		return state.goodsList;
	},
	// 商品杯数量，用于选择多张卡券
	getGoodsNum:state=>{
		let sum =0
		state.goodsList.map((item)=>{
			sum+=item.goodsNum
		})
		return sum
	},
	orderPrice: state => {
		// return 0
		//   订单价格
		let gplist = [] // 商品价格数组
		let clist = [] // 优惠券数组

		let sglilst=[] // 商品排序数组
		let sclist =[] // 优惠券排序数组
		let price = 0;
		if (state.goodsList) {
			for (let goodsItem of state.goodsList) {
				let singlePrice = goodsItem.price;
				if (goodsItem.specs) {
					for (let specItem of goodsItem.specs) {
						singlePrice = singlePrice + specItem.upPrice;
					}
				}
				// 商品价格
				for (let i = 1; i <= goodsItem.goodsNum; i++) {
					gplist.push(singlePrice)
					sglilst.push({[singlePrice]:goodsItem.goodsId})
				}
				price = price + singlePrice * goodsItem.goodsNum;
			}
			gplist.sort((a,b)=>b-a)
		}
		if (state.couponObj && state.couponObj.length>0) {
			state.couponObj.forEach(item => {
				clist.push(item.discountAmount) // 添加卡券金额
				sclist.push({[item.discountAmount]:item.userCardId}) // 添加卡券金额对应的卡券ID
			})
			clist.sort((a,b)=>b-a)
			// 防止原数组值被改变
			let orginclist = JSON.parse(JSON.stringify(clist)) 
			let orginglist = JSON.parse(JSON.stringify(gplist))

			// 优惠后的商品价格和优惠券价格
			let {goodlist,pricelist}=subduction(orginglist,orginclist)		
			let gpr=0,cpr=0
			// 合计减去优惠券实际优惠价格
			goodlist.forEach(pr=>gpr+=parseFloat(pr))
			price = gpr
			// 优惠券实际优惠价格
			pricelist.forEach(pr=>cpr+=parseFloat(pr))
			state.actual = cpr
		}
		state.sortedGoodsIdList = sordByKey(gplist,sglilst)
		state.sortedCardIdList = sordByKey(clist,sclist)
		// console.log(state.sortedCardIdList,clist,sclist,'排序后');
		return price;
	},
	getPrice: state => {
		let price = 0;
		if (state.goodsList) {
			for (let goodsItem of state.goodsList) {
				let singlePrice = goodsItem.price;
				if (goodsItem.specs) {
					for (let specItem of goodsItem.specs) {
						singlePrice = singlePrice + specItem.upPrice;
					}
				}
				price = price + singlePrice * goodsItem.goodsNum;
				// console.log(singlePrice,price,singlePrice * goodsItem.goodsNum);
			}
		}
		// price = parseFloat(price+'').toFixed(2)
		// console.log(price);
		return price;
	},
	getOfficalPrice: state => {
		let officialPrice = 0;
		if (state.goodsList) {
			for (let goodsItem of state.goodsList) {
				let singlePrice = goodsItem.officialPrice;
				if (goodsItem.specs) {
					for (let specItem of goodsItem.specs) {
						singlePrice = singlePrice + specItem.upPrice;
					}
				}
				officialPrice = officialPrice + singlePrice * goodsItem.goodsNum;
			}
		}
		return officialPrice;
	},

	getGoodsCount: (state, getters) => {
		return '';
	},
	getGoodsById: state => id => {
		return '';
	},
	getCountById: state => id => {
		if (state.goodsList) {
			let count = 0;
			for (let goods of state.goodsList) {
				if (id == goods.goodsId) {
					count = count + goods.goodsNum;
				}
			}
			if (count == 0) {
				return '';
			}
			return count;
		}
		return '';
	}
};

const mutations = {
	setOrderId(state, orderId) {
		state.orderId = orderId;
	},
	setHfOrderId(state,hfOrderId){
		state.hfOrderId = hfOrderId
	},
	setCouponObj(state, couponObj) {
		if (state.couponObj && state.goodsList) {
			let isFind = state.couponObj.find((item) => item.couponId == couponObj.couponId);
			if (couponObj && !isFind) {
				state.couponObj.push(couponObj);
			}
		}
		console.log(state.couponObj,'添加卡券','goods-store');
	},
	delCouponObj(state, couponObj) {
		if (state.couponObj) {
			let index = state.couponObj.findIndex((item) => item.couponId == couponObj.couponId)
			if (index >= 0) {
				state.couponObj.splice(index, 1)
			}
		}
		console.log(state.couponObj,'删除卡券','goods-store');
	},
	clearSortCoup(){
		state.sortedCardIdList =[]
	},
	setOrderCode(state, orderCode) {
		state.orderCode = orderCode;
	},
	addGoodsList(state, goods) {
		state.goodsList.push(goods);
	},
	updateGoodsList(state, goods) {
		for (let item of state.goodsList) {
			if (item.goodsId == goods.goodsId) {
				item.goodsNum = goods.goodsNum;
				break;
			}
		}
	},
	deleteGoodsList(state, id) {
		if (state.goodsList) {
			let del = 0;
			for (let i = 0; i < state.goodsList.length; i++) {
				if (state.goodsList[i].id == id) {
					del = i;
					break;
				}
			}
			state.goodsList.splice(del, 1);
		}
	},
	clearGoodsList(state) {
		state.goodsList = [];
		state.couponObj = [];
	},
	clearCouponObj(state) {
		state.couponObj = []
	},
	setGoodsList(state, goodsList) {
		state.goodsList = goodsList;
	},
	addNoSpecGoods(state, goods_item) {
		if (state.goodsList) {
			for (let goods of state.goodsList) {
				if (goods.goodsId == goods_item.goodsId) {
					goods.goodsNum = goods.goodsNum + 1;
					return;
				}
			}
		}
		state.goodsList.push({
			id: goods_item.id,
			thumb: goods_item.thumb,
			goodsNum: goods_item.goodsNum,
			name: goods_item.name,
			goodsId: goods_item.goodsId,
			price: goods_item.price,
			officialPrice: goods_item.officialPrice,
			specs: []
		})
	},
	// 商品列表，优惠券列表
	setSordByList(state,glist,clist){
		state.sortedGoodsIdList = glist
		state.sortedCardIdList = clist
	}
};

const actions = {

};

export default {
	state,
	getters,
	mutations,
	actions
};

